import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/sharedModule/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CarriersEffects } from './store/effects';
import * as fromCarriers from './store/reducers';
import { CarriersService } from './services';
import { CarrierFormComponent } from './components/carrier-form/carrier-form.component';
import { CarrierFormFieldComponent } from './components/carrier-form-field/carrier-form-field.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatRadioModule } from '@angular/material/radio';
import { CarriersRoutingModule } from './carriers-routing.module';
import { PageListComponent } from './components/main-list-carrier.component/main-list-carrier.component';
import { ListDropDownComponent } from './components/main-list-carrier.component/drop-down/list-drop-down.component';
import { ChooseCarrierComponent } from './components/choose-carrier.component/choose-carrier.component';
import { SideDrawerComponent } from './components/side-drawer.component/side-drawer.component';
import { CreateCarrierComponent } from './components/create-carrier.component/create-carrier.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EditCarrierComponent } from './components/edit-carrier.component/edit-carrier.component';
import { DeleteCarrierDialog } from './components/delete-carrier.dialog/delete-carrier.dialog';
import { ErrorResponseDialog } from './components/error-response.dialog/error-response.dialog';
import { CreateSuccessComponent } from './components/notification/create-success.component/create-success.component';
import { StorybookModule } from '@storybook/storybook.module';
import { eCommerceSubTenantsOptionsPipe } from './pipes/pipes';
import { JSONMappingFieldDialog } from './components/carrier-form-field/json-mapping-field.dialog/json-mapping-field.dialog';
import { FedExVerificationDialog } from './components/fedex-verification.dialog/fedex-verification.dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TrackstarConnectButtonComponent } from './components/trackstar-component/trackstar-component.component';

const PIPES = [eCommerceSubTenantsOptionsPipe];
@NgModule({
  declarations: [
    ...PIPES,
    CarrierFormComponent,
    CarrierFormFieldComponent,
    PageListComponent,
    ListDropDownComponent,
    ChooseCarrierComponent,
    SideDrawerComponent,
    CreateCarrierComponent,
    EditCarrierComponent,
    DeleteCarrierDialog,
    ErrorResponseDialog,
    CreateSuccessComponent,
    JSONMappingFieldDialog,
    FedExVerificationDialog,
    TrackstarConnectButtonComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    MatGridListModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatSelectModule,
    CarriersRoutingModule,
    ScrollingModule,
    StoreModule.forFeature(fromCarriers.featureKey, fromCarriers.reducer),
    EffectsModule.forFeature([CarriersEffects]),
    FlexLayoutModule,
    NgSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    StorybookModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [PageListComponent],
  providers: [CarriersService],
})
export class CarriersModule {}
